<!-- 找工作 工作详情 -->
<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- 广告 -->
    <div style="height: 100px"></div>
    <div class="add">
      <div class="addBg"><img :src="advertInfo.image" class="img" @click="linkOut(advertInfo.url)" /></div>
    </div>
    <div class="current">
      <div class="item">
        <span class="font-color-gray">当前位置：首页 > 新房 > 楼盘详情 > </span>
        <span>{{estateDetail.name}}</span>
      </div>
    </div>
    <!-- 楼盘首页 -->
    <div class="saleDetail">
      <div class="title">
        <div :class="isIndex == index ? 'title-items' : 'title-item'" v-for="(item, index) in titleList" :key="index" @click="linkPage(item.url, 'id', id)">
          {{ item.typeName }}
        </div>
      </div>
    </div>
    <div class="saleItem">
      <div class="jichu">基础信息</div>
      <div class="sale-flex">
        <div class="sale-flex-c">
          <div class="sale-flex-a">
            <div class="hui">楼盘名称</div>
            <div class="rights">{{ estateDetail.name }}</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">楼盘特点</div>
            <div class="" style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
              <div class="righte">{{ estateDetail.saleStatus }}</div>
              <div class="righte1" v-for="(item, index) in estateDetail.character" :key="index">{{ item }}</div>
            </div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">楼盘时间</div>
            <div class="right">{{ estateDetail.openStart }}</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">交房时间</div>
            <div class="right">{{ estateDetail.handoverTime }}</div>
          </div>
        </div>
        <div class="sale-flex-c" style="padding-left: 20px;">
          <div class="sale-flex-a">
            <div class="hui">参考价格</div>
            <div class="right">
              <div class="money">{{ estateDetail.price }}元/㎡</div>
            </div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">楼盘户型</div>
            <div class="right" v-for="(item, index) in houseType" :key="index">{{ item.typeName }},</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">楼盘地址</div>
            <div class="right">{{ estateDetail.address }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="saleItem">
      <div class="jichu">销售信息</div>
      <div class="sale-flex">
        <div class="sale-flex-c">
          <div class="sale-flex-a">
            <div class="hui">建筑类型</div>
            <div class="right">{{ estateDetail.buildType }}</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">物业费用</div>
            <div class="right">{{ estateDetail.propertyFee }}元/㎡/月</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">产权年限</div>
            <div class="right">{{ estateDetail.propertyYear }}年</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">交房时间</div>
            <div class="right">{{ estateDetail.handoverTime }}</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">总户数</div>
            <div class="right">{{ estateDetail.totalHouse }}户</div>
          </div>
        </div>
        <div class="sale-flex-c">
          <div class="sale-flex-a">
            <div class="hui">物业公司</div>
            <div class="right">{{ estateDetail.propertyCompany }}</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">开发商</div>
            <div class="right">{{ estateDetail.developer }}</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">建筑面积</div>
            <div class="right">{{ estateDetail.buildArea }}平米</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">占地面积</div>
            <div class="right">{{ estateDetail.coveredArea }}平米</div>
          </div>
          <div class="sale-flex-a">
            <div class="hui">容积率</div>
            <div class="right">{{ estateDetail.plotRatio }}</div>
          </div>
        </div>
      </div>
      <!-- 楼盘推荐 -->
      <div class="recommend">
        <div class="t flex-b-c">
          <div>楼盘推荐</div>
          <!-- 导航按钮 -->
          <div class="flex-c-c swiper-button-group">
            <div class="btnswiper next next-gray flex-c-c" v-if="flag1"><img src="../../../static/pC/prev.png" /></div>
            <div class="btnswiper next next-green flex-c-c" v-else><img src="../../../static/pC/prev.png" /></div>
            <div class="btnswiper prev prev-gray flex-c-c" v-if="flag"><img src="../../../static/pC/prev-1.png" /></div>
            <div class="btnswiper prev prev-green flex-c-c" v-else><img src="../../../static/pC/prev-1.png" /></div>
          </div>
        </div>

        <div class="swiper-container card-carousel-cards">
          <div class="swiper-wrapper">
            <div class="swiper-slide card-carousel--card" v-for="(item, index) in recommendList" :key="index" @click="linkPage('/jobDetail', 'id', item.id)">
              <img :src="item.avatar" />
              <div class="n">{{ item.name }}</div>
              <div class="money">{{ item.price }}元/㎡</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右侧导航 -->
    <RightNav></RightNav>

    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banners from '../../components/Banners.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetEstateDetail } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banners: Banners,
    RightNav: RightNav
  },
  data() {
    return {
      isIndex: 1,
      titleList: [
        { typeName: '楼盘首页', url: '/jobDetail' },
        { typeName: '楼盘详情', url: '/SaleDetail' },
        { typeName: '楼盘相册', url: '/BuildImg' },
        { typeName: '户型介绍', url: '/HouseType' },
        { typeName: '用户点评', url: '/evaluate' },
        // { typeName: '周边配套', url: '' },
        { typeName: '楼盘动态', url: '/Dynamics' }
      ],

      flag: false, //导航按钮是否到最末尾
      flag1: true, //导航按钮是否到最开头

      advertInfo: {}, //广告
      estateDetail: {}, //楼盘详情
      recommendList: [],
      houseType: [],
      id: '',
      login: false, //是否登录
      userInfo: [] //是否登录--用户信息
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.judgeLogin();
    this.getDetail(this.id);
  },
  methods: {
    //获取内容
    getDetail(id) {
      var id = id;
      let _this = this;
      apiGetEstateDetail({ id: id }).then(res => {
        if (res.success) {
          this.advertInfo = res.data.advertInfo;
          this.estateDetail = res.data.estateDetail;
          this.houseType = res.data.houseType; //楼盘户型
          this.recommendList = res.data.recommendList;
          this.$nextTick(() => {
            //等页面刷新完之后，再执行回调函数中的方法
            var swiper = new Swiper('.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 20,
              loop: false,
              navigation: {
                nextEl: '.prev',
                prevEl: '.next'
              },
              on: {
                slideChangeTransitionEnd: function() {
                  if (this.isEnd) {
                    _this.flag = true;
                  } else {
                    _this.flag = false;
                  }
                  if (this.isBeginning) {
                    _this.flag1 = true;
                  } else {
                    _this.flag1 = false;
                  }
                }
              }
            });
          });
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
      });
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },

    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: url, query: { id: key } }, onComplete => {}, onAbort => {});
      }
    },
    
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
  }
};
</script>
<style scoped>
/* 广告 */
.add {
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
}
.addBg {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.addBg .img {
  width: 100%;
}
/* 当前 */
.current {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
  margin-top: 30px;
  border-bottom: 1px solid #e5e5e5;
}
.current .item {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 14px;
}
/* 楼盘详情 */
.saleDetail {
  max-width: 1200px;
  margin: 30px auto 0 auto;
  display: flex;
}
.saleDetail .title {
  width: 100%;
  background-color: #345c4e;
  color: #fff;
  display: flex;
  align-items: center;
  height: 50px;
}
.saleDetail .title .title-item {
  width: 130px;
  text-align: center;
  cursor: pointer;
}
.saleDetail .title .title-items {
  width: 130px;
  text-align: center;
  background-color: #a98c60;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}
/* 楼盘详情 */
.saleItem {
  max-width: 1200px;
  margin: 30px auto 0 auto;
}
.jichu {
  font-size: 20px;
  font-weight: bold;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #e5e5e5;
}
.sale-flex {
  display: flex;
}
.sale-flex-c {
  width: 50%;
}
.sale-flex-a {
  display: flex;
  padding: 20px 0;
}
.hui {
  color: #999;
  font-size: 16px;
  min-width: 70px;
}
.right {
  margin-left: 30px;
}
.rights {
  color: #345c4e;
  margin-left: 30px;
}
.righte {
  margin-left: 30px;
  font-size: 14px;
  font-weight: 400;
  color: #a98c60;
  background: rgba(169, 140, 96, 0.3);
  padding: 2px 5px;
  margin-bottom: 10px;
}
.righte1 {
  margin-left: 30px;
  background: #f5f5f5;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  background: #f5f5f5;
  padding: 2px 5px;
  margin-bottom: 10px;
}
/* 楼盘推荐 */
.recommend {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;
}
.recommend .t {
  width: 100%;
  font-size: 22px;
  font-weight: bold;
}
.recommend .swiper-button-group {
}
.recommend .swiper-button-group .btnswiper {
  width: 30px;
  height: 30px;
}
.recommend .swiper-button-group .btnswiper img {
  width: 12px;
  height: 20px;
}
.recommend .swiper-button-group .prev {
  margin-left: 20px;
}
.recommend .swiper-button-group .next-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .next-green {
  background: #345c4e;
}
.recommend .swiper-button-group .prev-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .prev-green {
  background: #345c4e;
}
.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}
.card-carousel-cards .card-carousel--card {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  max-width: 100%;
  height: 227px;
  vertical-align: bottom;
  display: flex;
}
.card-carousel-cards .card-carousel--card .n {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
.card-carousel-cards .card-carousel--card .money {
  font-size: 16px;
  font-weight: bold;
  color: #345c4e;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Job/SaleDetail.vue